<div *ngIf="ticket?.has_pdf || ticket?.has_checklist; else cancel" class="checklists-ticket-pdf__actions">
  <app-icon *ngIf="ticket?.has_pdf" [size]="'18'" [glyph]="'check-circled'"></app-icon>

  <div *ngIf="ticket?.has_checklist" class="checklists-ticket-pdf__media" title="Скачать PDF">
    <app-loader *ngIf="isLoading" size="small"></app-loader>
    <app-icon
      *ngIf="!isLoading"
      class="checklists-ticket-pdf__download-icon"
      [size]="'18'"
      [glyph]="'download'"
      (click)="handleDownloadPdf(ticket)"
    >
    </app-icon>
  </div>
</div>
<ng-template #cancel>
  <app-icon [size]="'18'" [glyph]="'cancel-circled'"></app-icon>
</ng-template>
